// extracted by mini-css-extract-plugin
export default {"containerPrices":"N68J2","actualPrice":"JIybk","promo":"UI5aZ","longPrice":"h5qZ7","expiredPrice":"mfusP","discount":"I9OVl"};